import { memo, type FC } from "react";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface SelectedTagItem {
  value: string;
  label: string;
}

interface SelectedTagsProps {
  items: SelectedTagItem[];
  visibleCount: number;
  onRemove: (_value: string) => void;
}

const SelectedTags: FC<SelectedTagsProps> = ({ items, visibleCount, onRemove }) => {
  const { t } = useTranslation();
  const hiddenCount = items.length - visibleCount;

  if (!items.length) {
    return null;
  }

  return (
    <ul className="selected-tags">
      {items.slice(0, visibleCount).map(({ value, label }) => (
        <li key={value} className="selected-tags__tag">
          <span className="selected-tags__label">{label}</span>
          <button
            type="button"
            className="selected-tags__remove"
            aria-label={t("campaignFlow.aiWizard.productCategories.removeCategory", { name: label })}
            onClick={() => onRemove(value)}
          >
            <X size={12} aria-hidden />
          </button>
        </li>
      ))}
      {hiddenCount > 0 && (
        <li className="selected-tags__tag selected-tags__tag--more">+{hiddenCount}</li>
      )}
    </ul>
  );
};

export default memo(SelectedTags);
